import { render, staticRenderFns } from "./catalogo-usuarios.vue?vue&type=template&id=3bd9ca76&"
import script from "./catalogo-usuarios.vue?vue&type=script&lang=js&"
export * from "./catalogo-usuarios.vue?vue&type=script&lang=js&"
import style0 from "./catalogo-usuarios.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports